import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "@/contexts/i18n";
import { Box } from "@gemini/core";
import { useTestId } from "@/hooks";
import { useRefsContext } from "@/contexts/ref";
import { Section } from "@/components/UI";
import { TextButton } from "@gemini/ui";
import { FlagIcon } from "@gemini/icons";
import { useSeekerReport, useKeySection, } from "@/components/Sections/ClassifiedKeys";
import { IS_SERVER } from "@/constants";
import { useConfig } from "@/contexts/cdpConfig";
export const ClassifiedKeys = () => {
    const { t } = useI18n();
    const testId = useTestId("Sections.ClassifiedKeys");
    const keys = useKeySection();
    const { classifiedKeysRef } = useRefsContext();
    const seekerReportUrl = useSeekerReport();
    const isPreviewMode = useConfig().previewMode;
    if (!keys)
        return null;
    return (_jsxs(Section, { ref: classifiedKeysRef, testId: testId, unsafeClassname: "HideOnPrint", hasDivider: false, children: [_jsx(Box, { display: "flex", flexDirection: "column", gap: "spacing.8", children: keys &&
                    keys.map((key, index) => {
                        return (_jsxs(Box, { testId: `${testId}.Key.${index}`, children: [_jsxs("b", { children: [key.label, ": "] }), key.value] }, key.label));
                    }) }), seekerReportUrl && (_jsx(TextButton, { marginTop: "spacing.32", icon: FlagIcon, iconPosition: "start", onPress: () => {
                    if (IS_SERVER || isPreviewMode)
                        return;
                    window.open(seekerReportUrl, "_blank");
                }, testId: `${testId}.SeekerReport.CTA`, isDisabled: isPreviewMode, children: t("seeker_report.cta.label") }))] }));
};
